<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Solicitud De Reembolso Por Descuentos Indebidos" />
      <RefundForDiscount/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import RefundForDiscount from '@/components/RefundForDiscount/RefundForDiscount.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {}
  },
  name: 'RefundForDiscountRequestView',
  components: {
    RefundForDiscount,
    Header,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>